import { useEffect, useMemo, useState } from 'react';
import { CapabilityService } from '../../../util/services/capability';
import { VESSEL_TYPE } from '../../../util/varibles/constants';
import { IServiceTask, IVessel } from '../../../util/varibles/interface';

const useServiceTasks = (vessels: IVessel[]) => {
    const [allServiceTasks, setAllServiceTasks] = useState<IServiceTask[]>([]);
    const capabilityIds = useMemo(() => new Set(
        vessels
            .filter(vessel => vessel.type === VESSEL_TYPE.SERVICE)
            .flatMap(vessel => vessel.capabilities || [])
            .map(capability => capability.id),
    ), [vessels]);

    useEffect(() => {
        let active = true;

        CapabilityService.serviceTasks()
            .then(tasks => {
                if (!active) return;

                setAllServiceTasks(tasks);
            })
            .catch(error => {
                console.log('Get service tasks failed', error);
                if (active) setAllServiceTasks([]);
            });

        return () => {
            active = false;
        };
    }, []);

    return useMemo(() => allServiceTasks.filter(task => {
        const { capabilities = [] } = task;

        return capabilities.length === 0
            || capabilities.every(capability => capabilityIds.has(capability.id));
    }), [allServiceTasks, capabilityIds]);
};

export default useServiceTasks;
